import { TableRow, TableCell, TableHead } from '@mui/material';
import palette from 'src/theme/palette';

interface HeadCell {
  id: string;
  label: string;
  alignRight?: boolean;
}

interface UserListHeadProps {
  headLabel: HeadCell[];
  rowCount?: number;
}

export default function UserListHead({ headLabel }: UserListHeadProps) {
  return (
    <TableHead>
      <TableRow
        style={{
          padding: 0,
          height: 60,
          borderTop: `1.5px solid ${palette.divider}`,
        }}
      >
        {headLabel.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.alignRight ? 'right' : 'left'}
            style={{ paddingTop: 10, paddingBottom: 10, color: '#718096', fontSize: 16, fontWeight: 400 }}
          >
            {headCell.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
